var SortOrder;
(function (SortOrder) {
    SortOrder[SortOrder["ASCENDING"] = 0] = "ASCENDING";
    SortOrder[SortOrder["DESCENDING"] = 1] = "DESCENDING";
})(SortOrder || (SortOrder = {}));
var SortableTableRow = /** @class */ (function () {
    function SortableTableRow(element) {
        this.element = element;
        this.values = $(element).find('td').toArray().map(function (td) {
            var value = td.getAttribute('data-value') || '';
            if (value.match(/^\d+$/)) {
                return parseInt(value);
            }
            else {
                return value.toLocaleLowerCase();
            }
        });
    }
    SortableTableRow.prototype.compareTo = function (row, columnId) {
        return this.values[columnId - 1] < row.values[columnId - 1] ? -1 : 1;
    };
    return SortableTableRow;
}());
var SortableTable = /** @class */ (function () {
    function SortableTable(table) {
        var _this = this;
        this.currentSortOrder = SortOrder.ASCENDING;
        this.currentSortColumn = 1;
        this.table = table;
        this.tbody = table.tBodies[0];
        this.rows = this.getRows();
        $(table).on('click', '[data-sort-column]', function (evt) {
            var columnId = parseInt(evt.target.getAttribute('data-sort-column') || '');
            _this.sortByColumn(columnId);
            _this.redraw();
        });
    }
    SortableTable.prototype.getRows = function () {
        var rows = $(this.tbody).find('tr').toArray();
        return rows.map(function (tr) { return new SortableTableRow(tr); });
    };
    SortableTable.prototype.sortByColumn = function (columnId) {
        if (this.currentSortColumn === columnId) {
            this.currentSortOrder = this.inverseSortOrder();
        }
        else {
            this.currentSortColumn = columnId;
        }
        this.redraw();
    };
    SortableTable.prototype.inverseSortOrder = function () {
        if (this.currentSortOrder === SortOrder.ASCENDING) {
            return SortOrder.DESCENDING;
        }
        else {
            return SortOrder.ASCENDING;
        }
    };
    SortableTable.prototype.redraw = function () {
        this.sortRows();
        this.redrawHeaders();
        this.redrawRows();
    };
    SortableTable.prototype.sortRows = function () {
        var _this = this;
        this.rows.sort(function (a, b) { return a.compareTo(b, _this.currentSortColumn); });
        if (this.currentSortOrder === SortOrder.DESCENDING) {
            this.rows.reverse();
        }
    };
    SortableTable.prototype.redrawHeaders = function () {
        $(this.table).find('th').removeClass('ascending').removeClass('descending');
        var activeHeader = $(this.table).find("[data-sort-column=" + this.currentSortColumn + "]");
        activeHeader.addClass(this.currentSortOrder === SortOrder.ASCENDING ? 'ascending' : 'descending');
    };
    SortableTable.prototype.redrawRows = function () {
        var _this = this;
        this.rows.forEach(function (row) { return _this.tbody.appendChild(row.element); });
    };
    return SortableTable;
}());
jQuery(function () {
    $('table[data-sortable]').each(function (_, table) {
        new SortableTable(table); // eslint-disable-line no-new
    });
});
